const wowApp = require('angular').module('wowApp.shop');

wowApp.directive('wowCard', ['$compile', 'CardDetailService', require('./card-directive')]);

wowApp.directive('wowCardList', ['$timeout', '$location', '$q', 'SettingsService', 'CardDetailService', 'MoveFocus', 'BreakpointsService', 'InspirationService', '$compile', 'ShopPageStateService', 'SettingsByBreakpointService', 'CardSizeService', '$state', 'PageMetadataService', 'FiltersService', 'ProgressivePagingService', 'CacheService', 'CategoriesService', 'SearchService', '$window', 'AtmService', '$rootScope', require('./card-list-directive')]);
// Card detail
wowApp.directive('bwsDetailItem', ['TrolleyService', 'TrolleySource', require('./detail/common/detail-item-directive')]);
wowApp.service('CardDetailService', ['$state', '$q', require('./detail/card-detail-service')]);
wowApp.service('CardSizeService', ['SettingsService', 'BreakpointsService', 'LocalStorageService', require('./card-size-service')]);
wowApp.service('CardSortService', ['$state', 'LocalStorageService', require('./card-sort-service')]);


// Product Detail
wowApp.service('DetailProductService', ['Restangular', 'DecorateAdditionalDetails', require('./detail/product/detail-product-service')]);

wowApp.directive('wowDetailProductPage', ['$stateParams', 'DetailProductService', 'PageMetadataService', 'CategoriesService', '$state', '$uibModal', 'TrolleyService', 'SavedListsService', '$rootScope', 'AtmService', 'hyphenateFilter', '$timeout', 'StorePickerService', 'BreakpointsService', 'ShopPageStateService', 'SettingsService', '$log', 'BwsNotificationService', 'StorePickerPanelService', 'CurrentUserService', '$sce', 'CollectionTimeService', 'ShopperService', '$location', 'BadgeService', 'InMemoryStorage', require('./detail/product/detail-product-page-directive')]);

wowApp.value('currentProduct', {
	id: '',
	title: '',
	vintage: ''
});

wowApp.directive('wowRelatedProducts', ['$timeout', 'MoveFocus', 'DecorateAdditionalDetails', 'SearchService', 'AtmService', require('./detail/relatedproducts/related-products-directive')]);
wowApp.directive('wowRelatedProductCard', [require('./detail/relatedproducts/related-product-card-directive')]);
wowApp.factory('DecorateAdditionalDetails', [require('./detail/product/decorator/additional-details-decorator')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/index.js
 **/